// Read by Services/ClientConfig.ts, whose errorLink must not Logout() on a 401 from these
// operations: the same 401 rejects the engine's own mutate() call, and the engine turns it into
// a terminal "sign in again" state itself. Deliberately import-free: pulling the engine (React,
// jwt-decode, the gql documents) into the Apollo client's module graph would close an import
// cycle.

/** Operation names of the direct-to-S3 upload mutations; a 401 on these must not Logout(). */
export const UPLOAD_OPERATION_NAMES: string[] = [
  "ensureQuoteFileDirectories",
  "initQuoteFileUploads",
  "signQuoteFileUploadParts",
  "completeQuoteFileUploads",
  "abortQuoteFileUploads",
];
